import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Email as EmailIcon,
  ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  message: string;
  email: string;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open,
  onClose,
  message,
  email
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main' }} />
          <Typography variant="h4" color="success.main" fontWeight="bold">
            ¡Registro Exitoso!
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', px: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
          {message}
        </Typography>

        <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <EmailIcon />
            <Typography variant="subtitle2" fontWeight="bold">
              Revisa tu correo electrónico
            </Typography>
          </Box>
          <Typography variant="body2">
            Hemos enviado un enlace de verificación a: <strong>{email}</strong>
          </Typography>
        </Alert>

        <Box sx={{ textAlign: 'left', maxWidth: 400, mx: 'auto' }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Pasos siguientes:
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            1. 📧 Revisa tu bandeja de entrada (y spam)
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            2. 🔗 Haz clic en el enlace de verificación
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            3. ✅ Confirma tu cuenta
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            4. 🚀 Accede al portal con tu usuario y contraseña
          </Typography>
        </Box>

        <Alert severity="warning" sx={{ mt: 3, textAlign: 'left' }}>
          <Typography variant="body2">
            <strong>Importante:</strong> El enlace de verificación expira en 24 horas. 
            Si no lo recibes, revisa tu carpeta de spam o contacta a soporte.
          </Typography>
        </Alert>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3, px: 4 }}>
        <Button
          variant="contained"
          size="large"
          onClick={onClose}
          startIcon={<ArrowForwardIcon />}
          sx={{ 
            px: 4, 
            py: 1.5,
            fontSize: '1.1rem',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
            }
          }}
        >
          Ir al Login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
